import axios from 'axios';
const { REACT_APP_API_URL } = process.env;

const SEND_AUTH_ERROR_EMAIL_URL = `${REACT_APP_API_URL}/public/send-auth-error-email`;

export const sendAuthErrorEmail = async payload => {
  try {
    await axios.patch(SEND_AUTH_ERROR_EMAIL_URL, {
      authError: payload,
    });
  } catch (err) {
    console.error(err);
  }
};
